// extracted by mini-css-extract-plugin
export default {"container":"details_container__0lUgM","currency":"details_currency__zFFg0"};